import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from "@angular/core";
import { NzPaginationI18nInterface } from "ng-zorro-antd/i18n";
import { PaginationItemRenderContext, PaginationItemType } from "../../pagination.models";
import { NzPaginationItemComponent } from "ng-zorro-antd/pagination";

@Component({
  selector: "li[ui-pagination-item]",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "pagination-item.component.html",
})
export class UiPaginationItemComponent extends NzPaginationItemComponent {
  @Input("active") public active = false;
  @Input("locale") public locale!: NzPaginationI18nInterface;
  @Input("index") public index: number | null = null;
  @Input("disabled") public disabled = false;
  @Input("direction") public direction = "ltr";
  @Input("type") public type: PaginationItemType | string | null = null;
  @Input("itemRender") public itemRender: TemplateRef<PaginationItemRenderContext> | null = null;
  @Output("diffIndex") public readonly diffIndex = new EventEmitter<number>();
  @Output("gotoIndex") public readonly gotoIndex = new EventEmitter<number>();
}
